import { render, staticRenderFns } from "./interViewVideo.vue?vue&type=template&id=23a37547&"
import script from "./interViewVideo.vue?vue&type=script&lang=js&"
export * from "./interViewVideo.vue?vue&type=script&lang=js&"
import style0 from "./interViewVideo.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports